import React, { KeyboardEvent } from 'react';
import { Input, Button, Row, Col, Typography, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useAuth } from '../../auth/authcontext';

interface PageTreeActionsProps {
  newNodeTitle: string;
  setNewNodeTitle: (title: string) => void;
  addNode: () => void;
  content: React.ReactNode;
  isEditable: boolean;
}

const PageTreeActions: React.FC<PageTreeActionsProps> = ({
  newNodeTitle,
  setNewNodeTitle,
  addNode,
  content,
  isEditable,
}) => {
  const { isReadOnly } = useAuth();
  const isDisabled = !isEditable || isReadOnly;

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && newNodeTitle) {
      addNode();
    }
  };

  return (
    <>
      <div>{content}</div>

      <Divider style={{ backgroundColor: 'rgb(222 223 225)' }} />

      <Row gutter={16}>
        <Col span={12}>
          <Typography.Title level={5} style={{ fontSize: '14px' }}>
            Create a new child page
          </Typography.Title>
          <div style={{ display: 'flex' }}>
            <Input
              value={newNodeTitle}
              onChange={(e) => setNewNodeTitle(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter Child Page Name"
              maxLength={50}
              showCount
              allowClear
              style={{
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: '8px 0 0 8px',
                width: '100%',
                fontSize: '14px',
              }}
              disabled={isDisabled}
            />
            <Button
              icon={<PlusOutlined />}
              onClick={addNode}
              style={{ borderRadius: '0 8px 8px 0' }}
              disabled={!newNodeTitle || isDisabled}
            >
              Add
            </Button>
          </div>
        </Col>
        <Col span={12}></Col>
      </Row>
    </>
  );
};

export default PageTreeActions;